import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { JobsWrapper, ButtonWrapper } from "./style";
import { Button } from "../../Elements";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";

import Dropdown from "react-dropdown";
import "react-dropdown/style.css";

let jobTeam = "All teams";
let jobLocation = "All locations";
let jobType = "All types";
let teamValue = "All teams";
let locationValue = "All locations";
let typeValue = "All types";

let teams = [];
let teamData = [];
let locationData = [];
let jobTypeData = [];
let jobsData = [];
let initialJobsList = [];
let allJobsData = [];

const JOB_POSTING_SOURCE = {
	NONE: "none",
	LEVER: "lever",
};

const Jobs = (props) => {
	const [defaultJobs, setUpdatedJobs] = useState();
	const [filteredJobs, setUpdatedAllNewJobs] = useState();

	const { defaultShowCount, heading, source, noOpenRolesText } = props;
	const isNoJobPosting = source === JOB_POSTING_SOURCE.NONE;
	const isLeverJobPosting = source === JOB_POSTING_SOURCE.LEVER;

	useEffect(() => {
		const fetchJobs = async () => {
			fetch("https://api.lever.co/v0/postings/springboard?mode=json")
				.then((response) => response.json())
				.then((jsonData) => {
					jobsData = jsonData;
					allJobsData = jsonData;
					initialJobsList = jobsData.slice(0, defaultShowCount);
					setUpdatedJobs(initialJobsList);
					setUpdatedAllNewJobs(jobsData);
					let allTeam = [];
					jsonData.forEach((item) => {
						if (item?.categories?.department) {
							allTeam.push(item?.categories?.department);
						}
					});
					teams = allTeam.filter(function (item, pos) {
						return allTeam.indexOf(item) == pos;
					});
					teamData.push({
						value: "all",
						label: "All teams",
					});
					teams.forEach((data) => {
						teamData.push({
							value: data,
							label: data,
						});
					});
					let allLocations = [];
					jsonData.forEach((item) => {
						if (item?.categories?.location) {
							allLocations.push(item?.categories?.location);
						}
					});
					let locations = [];
					locations = allLocations.filter(function (item, pos) {
						return allLocations.indexOf(item) == pos;
					});
					locationData.push({
						value: "all",
						label: "All locations",
					});
					locations.forEach((data) => {
						locationData.push({
							value: data,
							label: data,
						});
					});
					let allJobTypes = [];
					jsonData.forEach((item) => {
						if (item?.categories?.commitment) {
							allJobTypes.push(item?.categories?.commitment);
						}
					});
					let jobTypes = [];
					jobTypes = allJobTypes.filter(function (item, pos) {
						return allJobTypes.indexOf(item) == pos;
					});
					jobTypeData.push({
						value: "all",
						label: "All types",
					});
					jobTypes.forEach((data) => {
						jobTypeData.push({
							value: data,
							label: data,
						});
					});
				})
				.catch((error) => {
					console.error(error);
				});
		};
		if (isLeverJobPosting) {
			fetchJobs();
		}
	}, []);

	const [showAll, setShowAll] = useState(false);
	const [showClearButton, setShowClearButton] = useState(false);
	const toggleShowAll = () => setShowAll(!showAll);

	const clearFilter = () => {
		teamValue = "all";
		locationValue = "all";
		typeValue = "all";
		jobTeam = "All teams";
		jobLocation = "All locations";
		jobType = "All types";
		filterFunction();
		setShowAll(false);
		setShowClearButton(false);
	};

	const handleTeamChange = (team) => {
		teamValue = team?.value;
		jobTeam = team?.label;
		filterFunction();
	};

	const handleLocationChange = (location) => {
		locationValue = location?.value;
		jobLocation = location?.label;
		filterFunction();
	};

	const handleTypeChange = (type) => {
		typeValue = type?.value;
		jobType = type?.label;
		filterFunction();
	};

	const filterFunction = () => {
		setShowAll(true);
		jobsData = allJobsData;
		let filteredTeamData;
		let filteredLocationData;
		let filteredTypeData;

		if (jobTeam != "All teams") {
			filteredTeamData = jobsData.filter(
				(job) => job?.categories?.department == jobTeam,
			);
		} else {
			filteredTeamData = jobsData;
		}
		if (jobLocation != "All locations") {
			filteredLocationData = filteredTeamData.filter(
				(job) => job?.categories?.location == jobLocation,
			);
		} else {
			filteredLocationData = filteredTeamData;
		}
		if (jobType != "All types") {
			filteredTypeData = filteredLocationData.filter(
				(job) => job?.categories?.commitment == jobType,
			);
		} else {
			filteredTypeData = filteredLocationData;
		}
		setUpdatedAllNewJobs(filteredTypeData);
		jobsData = filteredTypeData;
		if (filteredTypeData != allJobsData) {
			setShowClearButton(true);
		} else {
			setShowClearButton(false);
		}
	};

	return (
		<JobsWrapper id="jobs">
			<div className="heading">{heading}</div>
			{isLeverJobPosting && (
				<div className="filterContainer">
					<div className="teamType">
						<Dropdown
							options={teamData}
							onChange={(e) => handleTeamChange(e)}
							value={teamValue}
							placeholder="All teams"
						/>
					</div>
					<div className="location">
						<Dropdown
							options={locationData}
							onChange={(e) => handleLocationChange(e)}
							value={locationValue}
							placeholder="All locations"
						/>
					</div>
					<div className="jobType">
						<Dropdown
							options={jobTypeData}
							onChange={(e) => handleTypeChange(e)}
							value={typeValue}
							placeholder="All types"
						/>
					</div>
					{showClearButton && (
						<div onClick={clearFilter} className="filterWrapper">
							<CloudinaryImage
								url="https://res.cloudinary.com/springboard-images/image/upload/v1611843123/close-icon.png"
								sizes={{
									default: {
										height: 20,
									},
								}}
								lazyload
							/>
							<div className="clearFilterButton">Clear all filters</div>
						</div>
					)}
				</div>
			)}
			{jobsData?.length > 1 && !showClearButton && (
				<div className="openRoles">
					{jobsData?.length} open roles across all locations and all teams
				</div>
			)}
			{jobsData?.length > 1 && showClearButton && (
				<div className="openRoles">{jobsData?.length} open roles</div>
			)}
			{jobsData?.length == 1 && (
				<div className="openRoles">{jobsData?.length} open role</div>
			)}
			{jobsData?.length == 0 && isLeverJobPosting && (
				<div className="openRoles">
					No open roles match your search. Try removing filters or changing your
					search terms.
				</div>
			)}
			{isNoJobPosting && (
				<div className="openRoles">
					{noOpenRolesText ||
						"At the moment, we don’t have any open positions. However, we encourage you to check back later for future opportunities."}
				</div>
			)}
			{!showAll && (
				<div className="dataWrapper">
					<ul className="jobsList">
						{initialJobsList.map((job, index) => (
							<li key={index}>
								<a href={job?.hostedUrl} target="_blank">
									<span className="jobRole">{job?.text}</span>
									<span className="jobDetail">
										{job?.categories?.department}
									</span>
									<span className="jobDetail">{job?.categories?.location}</span>
									<span className="jobDetail">
										{job?.categories?.commitment}
									</span>
								</a>
							</li>
						))}
					</ul>
					{!isNoJobPosting && (
						<ButtonWrapper>
							<Button onClick={toggleShowAll} type="outline">
								Load more open roles
							</Button>
						</ButtonWrapper>
					)}
				</div>
			)}
			{showAll && (
				<div className="dataWrapper">
					<ul>
						{jobsData.map((job, index) => (
							<li key={index}>
								<a href={job?.hostedUrl} target="_blank">
									<span className="jobRole">{job?.text}</span>
									<span className="jobDetail">
										{job?.categories?.department}
									</span>
									<span className="jobDetail">{job?.categories?.location}</span>
									<span className="jobDetail">
										{job?.categories?.commitment}
									</span>
								</a>
							</li>
						))}
					</ul>
				</div>
			)}
		</JobsWrapper>
	);
};

Jobs.propTypes = {
	heading: PropTypes.string,
	defaultShowCount: PropTypes.string,
	showInTabletAndMobile: PropTypes.bool,
};

Jobs.defaultProps = {
	heading: "",
	defaultShowCount: "3",
	showInTabletAndMobile: true,
};

export default Jobs;
